import { Box, Container, Grid, IconButton, Typography } from "@mui/material";
import { Screen } from "../../../main/components/screen/Screen";
import TextDescription from "../components/TextDescription";
import { MainContext } from "../../../main/context/MainContextProvider";
import { useContext, useEffect, useRef, useState } from "react";
import { ClientInfo } from "../../clients/pages/ClientDetails";
import { Accordion } from "../../../main/components/accordion/Accordion";
import ListItem from "../components/ListItem";
import { serviceRequestApi } from "../../../services/api";
import { SismetroDetails } from "../types";
import Loading from "../../../main/components/Loading";
import { RopChart } from "../../../main/components/RopChart";
import CardBox from "../../../main/components/CardBox";
import { TypeInfo } from "../../../main/components/TypeInfo/TypeInfo";
import { formatDateAndHour } from "../../../main/utils/utils";

import Timeline from "@mui/lab/Timeline";
import TimelineItem from "@mui/lab/TimelineItem";
import TimelineSeparator from "@mui/lab/TimelineSeparator";
import TimelineConnector from "@mui/lab/TimelineConnector";
import TimelineContent from "@mui/lab/TimelineContent";
import TimelineDot from "@mui/lab/TimelineDot";
import TimelineOppositeContent from "@mui/lab/TimelineOppositeContent";
import { IoIosArrowBack } from "react-icons/io";
import { useNavigate } from "react-router-dom";

export default function ServiceRequestDetails() {
  const { isMobile } = useContext(MainContext);
  const elementRef = useRef(null);

  const navigate = useNavigate();
  const path = window.location.pathname;
  const idSs = path.split("/")[2];

  const [showDetailsAccordion, setShowDetailsAccordion] =
    useState<boolean>(false);
  const toggleDetailsAccordion = () => {
    setShowDetailsAccordion(!showDetailsAccordion);
  };
  const [loading, setLoading] = useState<boolean>(false);
  const [sismetro, setSismetro] = useState<SismetroDetails | null>(null);

  async function updateSismetro() {
    setLoading(true);
    try {
      const sismetroResponse = await serviceRequestApi.getSismetroDetails(
        Number(idSs)
      );
      setSismetro(sismetroResponse);
    } catch (error) {
      throw new Error("Erro ao carregar detalhes da SS");
    } finally {
      setLoading(false);
    }
  }

  const [horasLancamentoOpened, setHorasLancamentosOpened] = useState<string[]>(
    [""]
  );

  const toggleString = (id: string) => {
    if (horasLancamentoOpened.includes(id)) {
      const newArray = horasLancamentoOpened.filter((item) => item !== id);
      setHorasLancamentosOpened(newArray);
    } else {
      setHorasLancamentosOpened([...horasLancamentoOpened, id]);
    }
  };

  function StringVerificator(string: string): boolean {
    const hasString = horasLancamentoOpened.find((item) => item === string);
    return hasString !== undefined;
  }

  const historicoEvolucaoLength = sismetro?.historicoEvolucao.length;

  const option = {
    radar: {
      indicator: [
        { name: "Gravidade", max: 5 },
        { name: "Urgência", max: 5 },
        { name: "Tendência", max: 5 },
      ],
    },
    backgroundColor: "transparent",
    tooltip: {
      trigger: "item",
    },
    axisPointer: {
      show: true,
      label: {
        show: true,
      },
    },

    series: [
      {
        type: "radar",
        data: [
          {
            value: [
              sismetro?.gravidade ?? "Não Informado",
              sismetro?.urgencia ?? "Não Informado",
              sismetro?.tendencia ?? "Não Informado",
            ],
            name: "GUT",
          },
        ],
      },
    ],
  };

  useEffect(() => {
    updateSismetro();
  }, []);
  return (
    <Screen.Root>
      {loading ? (
        <>
          <Screen.Container>
            <Loading />
          </Screen.Container>
        </>
      ) : (
        <>
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          >
            <IconButton
              onClick={() => {
                navigate("/service-request/list");
              }}
              sx={{
                width: {
                  xs: "35px",
                  sm: "40px",
                },
                height: {
                  xs: "35px",
                  sm: "40px",
                },
              }}
            >
              <IoIosArrowBack />
            </IconButton>
          </Box>
          <Screen.Header
            sx={{
              marginBottom: { xs: "8px", sm: "32px" },
              display: "flex",
              flexDirection: "column",
              alignItems: "flex-start",
            }}
          >
            <Typography
              sx={{
                fontSize: "18px",
                fontWeight: "500",
              }}
            >
              {sismetro?.solicitante ?? "Não Informado"}
            </Typography>
            <TextDescription
              titleSx={{ fontSize: { xs: "15px", sm: "17px" } }}
              valueSx={{
                fontSize: { xs: "15px", sm: "17px" },
                fontWeight: "600",
              }}
              title="Localização:"
              value={sismetro?.localizacao ?? "Não Informado"}
            />
            <TextDescription
              titleSx={{ fontSize: { xs: "15px", sm: "17px" } }}
              valueSx={{
                fontSize: { xs: "15px", sm: "17px" },
                fontWeight: "600",
              }}
              title="Número da SS:"
              value={idSs}
            />
            <Box
              sx={{
                width: "100%",
                display: "flex",
                flexDirection: screen.width < 386 ? "column" : "row",
                justifyContent: isMobile ? "space-between" : undefined,
              }}
            >
              {sismetro && sismetro.dataAbertura && (
                <TextDescription
                  title="Abertura:"
                  value={formatDateAndHour(sismetro.dataAbertura)}
                />
              )}
              {sismetro && sismetro.dataEncerramento && (
                <TextDescription
                  title="Encerramento:"
                  value={formatDateAndHour(sismetro.dataEncerramento)}
                />
              )}
            </Box>
            <TextDescription title="Categoria:" value={sismetro?.categoria} />
          </Screen.Header>
          <Screen.Container>
            <CardBox
              sx={{
                width: "100%",
                height: "100%",
                display: "flex",
                flexDirection: "row",
              }}
            >
              <Box sx={{ width: { xs: "100%", sm: "50%" } }}>
                <TypeInfo.Root
                  sx={{
                    marginTop: "16px",
                    marginBottom: "32px",
                    display: "inline-flex",
                  }}
                  backgroundColor={getColorByGut(sismetro?.gut ?? 0)}
                >
                  <TypeInfo.Text
                    text={`GUT: ${sismetro?.gut ?? "Não Informado"}`}
                  />
                </TypeInfo.Root>
                <Container
                  ref={elementRef}
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    height: { xs: "140px", sm: "260px" },
                    justifyContent: "center",
                  }}
                >
                  <RopChart option={option} />
                </Container>
              </Box>
              <Box
                sx={{
                  width: { xs: "100%", sm: "50%" },
                  height: { xs: "220px", sm: "332px" },
                }}
              >
                <Typography sx={{ fontSize: { xs: "14px", sm: "17px" } }}>
                  Linha do tempo
                </Typography>
                {sismetro && sismetro.historicoEvolucao.length > 0 ? (
                  sismetro.historicoEvolucao.map((timeline, i) => (
                    <Timeline
                      sx={{
                        maxHeight: { xs: "181px", sm: "290px" },
                        overflow: "auto",
                      }}
                      position="alternate"
                      key={i}
                    >
                      <TimelineItem>
                        <TimelineOppositeContent
                          fontSize="14px"
                          color="text.secondary"
                        >
                          {timeline.dataHoraInicio}
                        </TimelineOppositeContent>
                        <TimelineSeparator>
                          <TimelineDot />
                          {historicoEvolucaoLength !== i + 1 && (
                            <TimelineConnector />
                          )}
                        </TimelineSeparator>
                        <TimelineContent fontSize="14px">
                          {timeline.evolucao}
                        </TimelineContent>
                      </TimelineItem>
                    </Timeline>
                  ))
                ) : (
                  <Typography
                    sx={{
                      fontSize: { xs: "14px", sm: "17px" },
                      width: "100%",
                      height: { xs: "181px", sm: "290px" },
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    Nenhum Registro Encontrado
                  </Typography>
                )}
              </Box>
            </CardBox>

            <Grid
              sx={{
                padding: { sm: "15px", xs: "15px" },
                flexDirection: "row",
                display: "flex",
                backgroundColor: "rgba(217, 217, 217, 0.1)",
                borderRadius: 2,
                marginTop: "8px",
                marginBottom: "8px",
                rowGap: "16px ",
              }}
              container
            >
              <Grid sx={{ display: "flex" }} item xs={12}>
                <Typography>Detalhes</Typography>
              </Grid>
              <ClientInfo
                removePaddingInMobile
                paddingLeft
                title="Aberto por"
                value={sismetro?.abertoPor}
              />
              <ClientInfo
                removePaddingInMobile
                paddingLeft
                title="TAG"
                value={sismetro?.tag}
              />
              <ClientInfo
                removePaddingInMobile
                paddingLeft
                title="Tipo Tec"
                value={sismetro?.tipoTec}
              />
              <ClientInfo
                removePaddingInMobile
                paddingLeft
                title="Abertura externa"
                value={"Não informado"}
              />
            </Grid>
            <Accordion.Root>
              <Accordion.Header
                toggleDetails={toggleDetailsAccordion}
                showDetails={showDetailsAccordion}
                title="Descrição"
                typographySx={{ fontSize: { xs: "13px", sm: "17px" } }}
              />
              <Accordion.Content showDetails={showDetailsAccordion}>
                {sismetro?.descricaoSs ?? "Não Informado"}
              </Accordion.Content>
            </Accordion.Root>
            <Grid
              sx={{
                padding: { sm: "15px", xs: "15px" },
                flexDirection: "row",
                display: "flex",
                justifyContent: isMobile ? "space-between" : "space-evenly",
                backgroundColor: "rgba(217, 217, 217, 0.1)",
                borderRadius: 2,
                marginTop: "8px",
                marginBottom: "8px",
                rowGap: "16px ",
              }}
              container
            >
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Typography sx={{ fontSize: { xs: "14px", sm: "17px" } }}>
                  Horas Trabalhadas
                </Typography>
                <Typography sx={{ fontSize: { xs: "12px", sm: "15px" } }}>
                  {sismetro?.horasTrabalhadas?.split(".")[0] ?? "Não Inofrmado"}
                </Typography>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                }}
              >
                <Typography sx={{ fontSize: { xs: "14px", sm: "17px" } }}>
                  Horas Paradas
                </Typography>
                <Typography sx={{ fontSize: { xs: "13px", sm: "17px" } }}>
                  {sismetro?.horasParadas ?? "Não Inofrmado"}
                </Typography>
              </Box>
            </Grid>
            <Grid
              item
              xs={12}
              sx={{ display: "flex", alignItems: "flex-start" }}
            >
              <Typography
                fontSize={{
                  xs: "14px",
                  sm: "17px",
                }}
                sx={{ paddingTop: "16px" }}
              >
                Histórico de Lançamentos
              </Typography>
            </Grid>
            {sismetro && sismetro.horasLancamentos.length > 0 ? (
              sismetro.horasLancamentos.map((horasLancamentos, i) => (
                <Accordion.Root key={i}>
                  <Accordion.Header
                    toggleDetails={() =>
                      toggleString(String(horasLancamentos.tecnico.id))
                    }
                    showDetails={StringVerificator(
                      String(horasLancamentos.tecnico.id)
                    )}
                    title={horasLancamentos.tecnico.nome ?? "Não informado"}
                    typographySx={{ fontSize: { xs: "13px", sm: "17px" } }}
                  />
                  <Accordion.Content
                    sx={{ marginTop: "none" }}
                    showDetails={StringVerificator(
                      String(horasLancamentos.tecnico.id)
                    )}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        width: "100%",
                        alignItems: "flex-start",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "14px",
                            sm: "17px",
                          },
                          marginBottom: "8px",
                        }}
                      >
                        Trabalhadas
                      </Typography>
                    </Box>
                    {horasLancamentos.lancamentos.length > 0
                      ? horasLancamentos.lancamentos.map((lancamentos, i) => (
                        <ListItem
                          key={i}
                          endDate={lancamentos.fim ?? "Não informado"}
                          startDate={lancamentos.inicio ?? "Não informado"}
                          status={lancamentos.status ?? "Não informado"}
                          tipo={lancamentos.tipo ?? "Não informado"}
                        />
                      ))
                      : "Nenhum Registro encontrado"}
                    <Box
                      sx={{
                        display: "flex",
                        width: "100%",
                        alignItems: "flex-start",
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: {
                            xs: "14px",
                            sm: "17px",
                          },
                          marginBottom: "8px",
                          marginTop: "16px",
                        }}
                      >
                        Paradas
                      </Typography>
                    </Box>
                    {horasLancamentos.paradas.length > 0
                      ? horasLancamentos.paradas.map((paradas, i) => (
                        <ListItem
                          key={i}
                          endDate={paradas.fim ?? "Não informado"}
                          startDate={paradas.inicio ?? "Não informado"}
                          status={paradas.status ?? "Não informado"}
                          tipo={paradas.tipo ?? "Não informado"}
                        />
                      ))
                      : "Nenhum Registro encontrado"}
                  </Accordion.Content>
                </Accordion.Root>
              ))
            ) : (
              <Grid item xs={12}>
                <Typography
                  fontSize={{
                    xs: "14px",
                    sm: "17px",
                  }}
                  sx={{ paddingTop: "48px", paddingBottom: "32px" }}
                >
                  Nenhum Registro encontrado
                </Typography>
              </Grid>
            )}
          </Screen.Container>
        </>
      )}
    </Screen.Root>
  );
}

export function getColorByGut(gut: number) {
  if (gut < 50) return "#0d6efd";
  if (gut > 50) return "#FF9F0C";
  if (gut > 100) return "#FF0000";
}
